"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import { Divider, Space } from "antd";
import { CodeOutlined, GithubOutlined } from "@ant-design/icons";
import { OutsideLink } from "@/components/OutsideLink";
import next_logo from "@/assets/images/logo/frontend/next.svg";
import vercel_logo from "@/assets/images/logo/frontend/vercel.svg";
import cloudflare_logo from "@/assets/images/logo/Cloudflare_Logo.svg";
import tidb_cloud_logo from "@/assets/images/logo/database/TiDBCloud_Logo.png";
import { useTranslations } from "next-intl";
import styles from "./Footer.module.sass";
export interface IPropsFooter {
  /**
   * Resolved by the server layout. Computing the year inside this client component
   * made server and client disagree across a New Year boundary (hydration
   * mismatch), and doing it in an effect to avoid that is exactly the
   * cascading-render pattern `react-hooks/set-state-in-effect` rejects.
   */
  year: number;
}
export const Footer: React.FunctionComponent<IPropsFooter> = t0 => {
  const $ = _c(60);
  const {
    year
  } = t0;
  const t = useTranslations("footer");
  let t1;
  if ($[0] !== t || $[1] !== year) {
    t1 = t("copyright", {
      year
    });
    $[0] = t;
    $[1] = year;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p>{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CodeOutlined data-sentry-element="CodeOutlined" data-sentry-source-file="Footer.tsx" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("sourceCode");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <OutsideLink href="https://github.com/cw1997/www.changwei.me" data-sentry-element="OutsideLink" data-sentry-source-file="Footer.tsx">cw1997/www.changwei.me</OutsideLink>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("isUnder");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <OutsideLink href="https://www.apache.org/licenses/LICENSE-2.0" data-sentry-element="OutsideLink" data-sentry-source-file="Footer.tsx">Apache License, Version 2.0 (Apache 2.0)</OutsideLink>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t6) {
    t8 = <p>{t3} {t4} [{t5}] {t6}{" "}{t7}</p>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <GithubOutlined data-sentry-element="GithubOutlined" data-sentry-source-file="Footer.tsx" />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("githubRepo");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <OutsideLink href="https://github.com/cw1997/www.changwei.me" data-sentry-element="OutsideLink" data-sentry-source-file="Footer.tsx" />;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10) {
    t12 = <p>{t9} {t10}{" "}{t11}</p>;
    $[19] = t10;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      marginTop: 8
    };
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div><Space wrap={true} data-sentry-element="Space" data-sentry-source-file="Footer.tsx"><img alt="GitHub Repo stars" src="https://img.shields.io/github/stars/cw1997/www.changwei.me" loading="lazy" decoding="async" /><img alt="GitHub Repo watchers" src="https://img.shields.io/github/watchers/cw1997/www.changwei.me" loading="lazy" decoding="async" /><img alt="GitHub Repo forks" src="https://img.shields.io/github/forks/cw1997/www.changwei.me" loading="lazy" decoding="async" /><img alt="GitHub branch status" src="https://img.shields.io/github/checks-status/cw1997/www.changwei.me/main" loading="lazy" decoding="async" /><img alt="GitHub last commit" src="https://img.shields.io/github/last-commit/cw1997/www.changwei.me?style=flat" loading="lazy" decoding="async" /><img alt="GitHub Created At" src="https://img.shields.io/github/created-at/cw1997/www.changwei.me" loading="lazy" decoding="async" /><img alt="GitHub repo size" src="https://img.shields.io/github/repo-size/cw1997/www.changwei.me" loading="lazy" decoding="async" /></Space></div>;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div style={t13}>{t14}<div><Space wrap={true} data-sentry-element="Space" data-sentry-source-file="Footer.tsx"><img alt="GitHub followers" src="https://img.shields.io/github/followers/cw1997" loading="lazy" decoding="async" /><img alt="GitHub User's stars" src="https://img.shields.io/github/stars/cw1997" loading="lazy" decoding="async" /><img alt="X (formerly Twitter) Follow" src="https://img.shields.io/twitter/follow/changwei1006" loading="lazy" decoding="async" /></Space></div></div>;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t12 || $[25] !== t8) {
    t16 = <div className={styles.nerd_info}>{t8}{t12}{t15}</div>;
    $[24] = t12;
    $[25] = t8;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t16 || $[28] !== t2) {
    t17 = <div>{t2}{t16}</div>;
    $[27] = t16;
    $[28] = t2;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Divider data-sentry-element="Divider" data-sentry-source-file="Footer.tsx" />;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Divider orientation="vertical" />;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t) {
    t20 = t("poweredBy");
    $[32] = t;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <OutsideLink className={styles.logo} href="https://nextjs.org/" data-sentry-element="OutsideLink" data-sentry-source-file="Footer.tsx"><Image src={next_logo} alt="NextJS Logo" height={16} data-sentry-element="Image" data-sentry-source-file="Footer.tsx" /></OutsideLink>;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== t20) {
    t22 = <div className={styles.powered_by_item}>{t20}{t21}</div>;
    $[35] = t20;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== t) {
    t23 = t("hostedOn");
    $[37] = t;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <OutsideLink className={styles.logo} href="https://vercel.com" data-sentry-element="OutsideLink" data-sentry-source-file="Footer.tsx"><Image src={vercel_logo} alt="Vercel Logo" height={16} data-sentry-element="Image" data-sentry-source-file="Footer.tsx" /></OutsideLink>;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] !== t23) {
    t25 = <div className={styles.powered_by_item}>{t23}{t24}</div>;
    $[40] = t23;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== t) {
    t26 = t("cdn");
    $[42] = t;
    $[43] = t26;
  } else {
    t26 = $[43];
  }
  let t27;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <OutsideLink className={styles.logo} href="https://cloudflare.com" data-sentry-element="OutsideLink" data-sentry-source-file="Footer.tsx"><Image src={cloudflare_logo} alt="CloudFlare Logo" height={32} data-sentry-element="Image" data-sentry-source-file="Footer.tsx" /></OutsideLink>;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  let t28;
  if ($[45] !== t26) {
    t28 = <div className={styles.powered_by_item}>{t26}{t27}</div>;
    $[45] = t26;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  if ($[47] !== t) {
    t29 = t("database");
    $[47] = t;
    $[48] = t29;
  } else {
    t29 = $[48];
  }
  let t30;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <OutsideLink className={styles.logo} href="https://tidbcloud.com" data-sentry-element="OutsideLink" data-sentry-source-file="Footer.tsx"><Image src={tidb_cloud_logo} alt="TiDB Cloud Logo" height={32} data-sentry-element="Image" data-sentry-source-file="Footer.tsx" /></OutsideLink>;
    $[49] = t30;
  } else {
    t30 = $[49];
  }
  let t31;
  if ($[50] !== t29) {
    t31 = <div className={styles.powered_by_item}>{t29}{t30}</div>;
    $[50] = t29;
    $[51] = t31;
  } else {
    t31 = $[51];
  }
  let t32;
  if ($[52] !== t22 || $[53] !== t25 || $[54] !== t28 || $[55] !== t31) {
    t32 = <div><Space align="center" className={styles.powered_by_list} separator={t19} wrap={true} data-sentry-element="Space" data-sentry-source-file="Footer.tsx">{t22}{t25}{t28}{t31}</Space></div>;
    $[52] = t22;
    $[53] = t25;
    $[54] = t28;
    $[55] = t31;
    $[56] = t32;
  } else {
    t32 = $[56];
  }
  let t33;
  if ($[57] !== t17 || $[58] !== t32) {
    t33 = <footer className={styles.container} data-sentry-component="Footer" data-sentry-source-file="Footer.tsx"><div className={styles.content}>{t17}{t18}{t32}</div></footer>;
    $[57] = t17;
    $[58] = t32;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  return t33;
};